export const RESOLUTION = 4; // Sections each hour on the grid is divided into

export const FIVE_MINUTES = 5;
export const FIFTEEN_MINUTES = 15;
export const THIRTY_MINUTES = 30;

export const FIVE_MINUTES_DECIMAL = 1 / (60 / FIVE_MINUTES);
export const FIFTEEN_MINUTES_DECIMAL = 1 / (60 / FIFTEEN_MINUTES);
export const THIRTY_MINUTES_DECIMAL = 1 / (60 / THIRTY_MINUTES);

export const SNAP_TO_MINUTES = FIVE_MINUTES;
export const SNAP_TO_MINUTES_DECIMAL = 1 / (60 / SNAP_TO_MINUTES);
export const KEY_CODE_ESCAPE = 27;

// Events
export const EVENT_OVERLAY_CHANGING = 'overlay:changing';
export const EVENT_OVERLAY_CHANGED = 'overlay:changed';
export const EVENT_DRAG_STARTED = 'drag:started';
export const EVENT_DRAG_FINISHED = 'drag:finished';
export const EVENT_DRAG_OVERLAY_CLASH = 'drag:overlay-clash';
export const EVENT_CLEAR_SELECTION = 'selection:clear';
export const EVENT_NEW_EVENT_CLASH = 'new-event:clash';

// Make sure we have at least 1 pixel per minute
export const ZOOM_HOUR_WIDTHS = [72, 90, 120, 150];
export const ZOOM_ROW_HEIGHTS = [40, 56, 72, 88];

export const overlayDoubleClickTimeout = 400;

export const COLUMNS_PER_HOUR = 40;
